import TransferForm from "./transfers-form.component";
import TransferStatus from "./transfer-status.component";
import { Stepper } from '@mui/material';
import { useState, } from 'react';
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
interface IProps {
}

const TransferCredits = (props: IProps) => {
    const [activeStep, setActiveStep] = useState(0);
    const [stepdata, setStepdata] = useState<any>()
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    const handleNext = (data?: any) => {
        setStepdata({ ...stepdata, ...data })
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    const steps = [
        {
            label: "transfor",
            component: <TransferForm HandleNext={handleNext} Stepdata={stepdata} />
        },
        {
            label: "form",
            component: <TransferStatus HandleNext={handleNext} Stepdata={stepdata} />
        }
    ]

    return (
        <div className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-current-plan-background"} h-v-75 my-auto`}>
            <Stepper activeStep={activeStep} alternativeLabel className={'w-80 mb-3'} >
                {/* {steps.map((step, index) => (
                        <Step key={index} onClick={() => setBack(index)}>
                            <StepLabel >{step.label}</StepLabel>
                        </Step>
                    ))} */}
            </Stepper>
            <div className='d-flex'>
                {steps[activeStep].component}
            </div>
        </div>
    )
}
export default TransferCredits;